import { createColumnHelper } from '@tanstack/react-table';
import { TFunction } from 'i18next';
import { formatNumericValue } from 'utils/general';

import { IReconciliation } from '@/modules/workingDayReconciliation/types';
import { Typography } from '@/shared/components/atoms';
import TippyTooltip from '@/shared/components/atoms/TippyTooltip';
import { IGeneral } from '@/shared/types';

import TriangleExleminationMark from '~/images/shared/TriangleExleminationMark.svg';

export const getSettlementLevel = (
  type: string | string[] | undefined
): IGeneral.ISettlementLevel => {
  return type === 'worker' ? 2 : 1;
};
export const getWorkersTable = (t: TFunction, currency: string) => {
  const columnHelper =
    createColumnHelper<IReconciliation.IGetWorkerDailyDuesDetails>();

  return [
    columnHelper.accessor('workerName', {
      header: t('worker'),
      cell: ({
        row: {
          original: { workerName, unitMismatch },
        },
      }) => (
        <div className='flex items-center gap-8'>
          <Typography>{workerName}</Typography>
          {unitMismatch ? (
            <TippyTooltip
              content={
                <Typography variant='caption'>
                  {t('worker-with-unit-mismatch')}
                </Typography>
              }
              maxWidth={277}
              arrow
              animation
              placement='bottom'
            >
              <span className='text-base text-tertiary-default'>
                <TriangleExleminationMark />
              </span>
            </TippyTooltip>
          ) : (
            ''
          )}
        </div>
      ),
    }),
    columnHelper.accessor('crewName', {
      header: t('Crew'),
      cell: ({ getValue }) => (
        <Typography className='text-surface-10'>{getValue()}</Typography>
      ),
    }),
    columnHelper.accessor('totalHours', {
      header: t('total-hours'),
      cell: ({
        row: {
          original: { totalHours },
        },
      }) => <Typography>{formatNumericValue(totalHours ?? 0)}</Typography>,
    }),
    columnHelper.accessor('totalOperations', {
      header: t('total-operations'),
      cell: ({
        row: {
          original: { totalOperations },
        },
      }) => <Typography>{formatNumericValue(totalOperations ?? 0)}</Typography>,
    }),
    columnHelper.accessor('basePay', {
      header: `${t('base-pay')} (${currency})`,
      cell: ({
        row: {
          original: { basePay },
        },
      }) => <Typography>{formatNumericValue(basePay ?? 0)}</Typography>,
    }),
    columnHelper.accessor('totalBonuses', {
      header: `${t('bonus')} (${currency})`,
      cell: ({
        row: {
          original: { totalBonuses },
        },
      }) => <Typography>{formatNumericValue(totalBonuses ?? 0)}</Typography>,
    }),
    columnHelper.accessor('totalDeductions', {
      header: `${t('deduction')} (${currency})`,
      cell: ({
        row: {
          original: { totalDeductions },
        },
      }) => <Typography>{formatNumericValue(totalDeductions ?? 0)}</Typography>,
    }),
    columnHelper.accessor('totalOvertime', {
      header: `${t('OVERTIME')} (${currency})`,
      cell: ({
        row: {
          original: { totalOvertime },
        },
      }) => <Typography>{formatNumericValue(totalOvertime ?? 0)}</Typography>,
    }),
    columnHelper.accessor('totalPay', {
      header: `${t('total-pay')} (${currency})`,
      cell: ({
        row: {
          original: { totalPay },
        },
      }) => <Typography>{formatNumericValue(totalPay ?? 0)}</Typography>,
    }),
  ];
};
